export default __webpack_public_path__ + "static/media/mic-off-white.0899a92c.svg";